module.exports = __webpack_public_path__ + "static/media/Froilan Campos.d1fb8bbf.png";